
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//    <React.StrictMode>
//     <BrowserRouter> {/* Wrap App with BrowserRouter */}
//       <App />
//     </BrowserRouter>
//    </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// serviceWorkerRegistration.register();

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import { LanguageProvider } from './context/LanguageContext'; // ✅ Add this

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <LanguageProvider> {/* ✅ Wrap the entire app in LanguageProvider */}
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </LanguageProvider>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app...
// reportWebVitals();
// serviceWorkerRegistration.register();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { LanguageProvider } from './context/LanguageContext'; // ✅ Language context
import { SearchProvider } from './context/SearchContext';     // ✅ Search context

// Guard against the "removeChild/insertBefore: node is not a child" crash that
// happens when Google Translate rewrites the DOM and React later tries to
// update those nodes. See https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('Skipped removeChild on a node that was moved by translation.');
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('Skipped insertBefore for a reference node moved by translation.');
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <LanguageProvider> {/* ✅ Global language control */}
      <SearchProvider> {/* ✅ Global search state control */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SearchProvider>
    </LanguageProvider>
  </React.StrictMode>
);

// Performance metrics (optional)
reportWebVitals();
serviceWorkerRegistration.register();
